import React from "react";

import { contact } from "../data";

const Contact = () => {
    return (
        <section id="contact" className="section bg-primary">
            <div className="container mx-auto">
                <div className="flex flex-col items-center text-center">
                    <h2 className="section-title before:content-contact relative before:absolute before:opacity-10 before:-top-16 before:-left-40 before:hidden before:lg:block">
                        Contact me
                    </h2>
                    <p className="mb-4 text-accent">Let's Get in Touch</p>
                    <p className="subtitle">
                        Ready to bring your digital vision to life or have a
                        question about my services? I'd love to hear from you.
                        Drop me a message below or shoot me an email, and I'll
                        get back to you as soon as possible. Your next digital
                        adventure starts here.
                    </p>
                </div>
                <div className="flex flex-col lg:gap-x-8 lg:flex-row">
                    <div className="flex flex-1 flex-col items-start space-y-8 mb-12 lg:mb-0 lg:pt-2">
                        {contact.map((item, index) => {
                            const { icon, title, subtitle, description } = item;
                            return (
                                <div
                                    className="flex flex-col lg:flex-row gap-x-4"
                                    key={index}
                                >
                                    <div className="text-accent rounded-sm w-14 h-14 flex items-start justify-center mt-2 mb-4 lg:mb-0 text-2xl">
                                        {icon}
                                    </div>
                                    <div className="">
                                        <h4 className="font-body text-xl mb-1 ">
                                            {title}
                                        </h4>
                                        <p className="mb-1">{subtitle}</p>
                                        <br />
                                        <p className="mb-1 ">
                                            Use the form, or email me directly
                                            at
                                        </p>

                                        <p className="text-greenAccent hover:text-accent font-normal cursor-pointer transition-all duration-300 ease-in-out">
                                            <a href="mailto:mario@mariopolchert.com">
                                                {description}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <form action="" className="space-y-8 w-full max-w-[780px]">
                        <div className="flex justify-between  ">
                            <input
                                className="input mr-4"
                                type="text"
                                placeholder="Your name"
                            />
                            <input
                                className="input ml-4"
                                type="email"
                                placeholder="Your email"
                            />
                        </div>
                        <input
                            type="text"
                            className="input"
                            placeholder="Subject"
                        />
                        <textarea
                            className="textarea"
                            placeholder="Your message"
                        ></textarea>
                        <button className="btn btn-lg bg-accent hover:bg-accent-hover">
                            Send message
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Contact;
